// src/components/AIAnswerBox.ts
import "./AIAnswerBox.css";
import type { AiOverviewData } from "./AiOverview";

export function renderAIAnswerBox(
  container: HTMLElement,
  data: Partial<AiOverviewData> | null,
  isLoading: boolean = false,
  error: string | null = null,
) {
  if (isLoading) {
    container.innerHTML = `
      <div class="ai-box">
        <p class="ai-overview-text">Thinking…</p>
      </div>
    `;
    return;
  }

  if (error) {
    container.innerHTML = `
      <div class="ai-box">
        <p class="ai-overview-text">AI Overview unavailable.</p>
      </div>
    `;
    return;
  }

  if (!data) {
    container.innerHTML = "";
    return;
  }

  // === Same logic as your React version ===
  const rawOverview = data.overview as unknown;
  let answer = "";

  if (typeof rawOverview === "string") {
    answer = rawOverview;
  } else if (
    rawOverview &&
    typeof rawOverview === "object" &&
    "content" in rawOverview &&
    Array.isArray((rawOverview as { content: unknown }).content)
  ) {
    answer = ((rawOverview as { content: string[] }).content || []).join(" ");
  }

  const sources = ((data as unknown as { sources?: string[] }).sources ??
    []) as string[];

  container.innerHTML = `
    <div class="ai-box">
      <h2 class="ai-title">AI Answer</h2>

      ${answer ? `<p class="ai-overview-text">${escapeHtml(answer)}</p>` : ""}

      ${
        sources.length > 0
          ? `
        <div class="ai-sources">
          <strong>Sources:</strong>
          <ul>
            ${sources
              .map(
                (src: string, i: number) =>
                  `<li key="${i}">${escapeHtml(src)}</li>`,
              )
              .join("")}
          </ul>
        </div>
      `
          : ""
      }
    </div>
  `;
}

// Simple HTML escape for security
function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
